import { render } from "./ContentDetail.vue?vue&type=template&id=cdb82500&scoped=true"
import script from "./ContentDetail.vue?vue&type=script&lang=js"
export * from "./ContentDetail.vue?vue&type=script&lang=js"

import "./ContentDetail.scss?vue&type=style&index=0&id=cdb82500&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdb82500"]])

export default __exports__